/** Escape a string for use inside a double-quoted CSS attribute selector. */
export function escapeAttrForSelector(s) {
  return String(s).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
}